/* Jedno miesto, kde téma reaguje na zmenu veľkosti okna.

   Prečo to existuje:
   Na iPhone spúšťa štipkový zoom udalosti `visualViewport.resize` desiatky
   ráz za sekundu, pričom rozloženie stránky sa vôbec nemení — mení sa len
   to, na akú časť sa zákazník pozerá. Téma na ne mala sedem nezávislých
   obsluh, ktoré pri každej z nich merali prvky a zapisovali CSS premenné.
   Meranie po zápise vynúti prepočet rozloženia, takže prudký zoom znamenal
   stovky prepočtov za sekundu — presne tá záťaž, po ktorej Safari stránku
   zabije s hláškou „A problem occurred with this webpage“.

   Čo s tým robí tento súbor:
     • zlúči všetky obsluhy do jednej, spustenej raz za snímku (rAF);
     • preskočí ju, keď sa šírka ani výška okna reálne nezmenili — čo je
       pri zoome vždy;
     • `onWidthChange` navyše ignoruje aj zmeny výšky, ktoré na mobile
       spôsobuje len skrývanie adresného riadku prehliadača.

   Použitie:
     AOViewport.onResize(fn)      – zmena šírky alebo výšky okna
     AOViewport.onWidthChange(fn) – iba skutočná zmena šírky
     AOViewport.isZooming()       – práve prebieha štipkový zoom
*/
(() => {
  'use strict';
  if (window.AOViewport) return;

  const listeners = new Set();
  let lastWidth = window.innerWidth;
  let lastHeight = window.innerHeight;
  let frame = 0;

  const isZooming = () => {
    const vv = window.visualViewport;
    return Boolean(vv) && Math.abs(vv.scale - 1) > 0.01;
  };

  const flush = () => {
    frame = 0;
    const width = window.innerWidth;
    const height = window.innerHeight;
    const widthChanged = width !== lastWidth;
    const heightChanged = height !== lastHeight;
    if (!widthChanged && !heightChanged) return;
    lastWidth = width;
    lastHeight = height;
    const detail = { width, height, widthChanged, heightChanged };
    listeners.forEach((entry) => {
      if (entry.widthOnly && !widthChanged) return;
      try {
        entry.fn(detail);
      } catch (error) {
        // Jedna chybná obsluha nesmie zhodiť ostatné.
        if (window.console && console.warn) console.warn('AOViewport', error);
      }
    });
  };

  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(flush);
  };

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  const add = (fn, widthOnly) => {
    if (typeof fn !== 'function') return () => {};
    const entry = { fn, widthOnly };
    listeners.add(entry);
    return () => listeners.delete(entry);
  };

  window.AOViewport = {
    onResize: (fn) => add(fn, false),
    onWidthChange: (fn) => add(fn, true),
    isZooming,
  };
})();
